import styles from "./ImpersonationBanner.module.scss";
import { RenderWhen } from "../../../infrastructure/components/RenderWhen";
import { useImpersonationBanner } from "../hooks/useImpersonationBanner";

export const ImpersonationBanner = () => {
  const { isVisible, adminName, userName, exit } = useImpersonationBanner();

  return (
    <RenderWhen condition={isVisible}>
      <div
        className={styles.root}
        role="status"
        title={`Влизане от админ панела: ${adminName}`}
      >
        <span className={styles.root_dot} />
        <span className={styles.root_text}>
          Профил на <strong>{userName}</strong>
        </span>
        <button type="button" className={styles.root_exit} onClick={exit}>
          Изход
        </button>
      </div>
    </RenderWhen>
  );
};
